// src/components/Products.js
import React, { useEffect, useState } from 'react';
import ProductList from './ProductList';
// ** Import useSearchParams to read URL query parameters **
import { useSearchParams } from 'react-router-dom';

// ** Receive customerDiscount prop **
const Products = ({ customerDiscount }) => {
    // REMOVE: useParams for discount is no longer needed
    // const { discount } = useParams();
    // const discountPercent = discount ? parseFloat(discount) : 0;

    // Use the passed customerDiscount prop
    const discountPercent = customerDiscount;

    // Get search query parameter from URL
    const [searchParams] = useSearchParams();
    const querySearchTerm = searchParams.get('search') || ''; // Get 'search' param or default to empty

  return (
    // ** Add padding/margin if needed due to fixed/sticky global header **
    <div className="products-page-content">
        {/* REMOVE the <header> section, it's now global in App.js */}
        {/* REMOVE the <div className="tophead"> section, it's now global in Header.js */}

        <br /><br /><br /><br /><br /><br /> {/* Keep spacing if needed */}

        <section className="products" id="products">
            <h1 className="heading"> All <span>Products</span> </h1>
            {/* Pass discount prop AND the search term from URL query */}
            <ProductList
                initialLimit={12} // Adjust limit if needed
                customerDiscount={discountPercent}
                initialSearchTerm={querySearchTerm} // Pass search term from URL
            />
        </section>
    </div>
  )
}

export default Products;